<template>
  <div class="mt-0 elegant-container">
    <v-layout wrap>
      <v-flex>
        <section>
          <div class="customer-page">
            <!-- Animated Background -->
            <div class="animated-bg">
              <div class="bg-shape shape-1"></div>
              <div class="bg-shape shape-2"></div>
              <div class="bg-shape shape-3"></div>
            </div>
            <v-dialog v-model="dialog.status"
              @keydown.esc="dialog.status = false"
              :fullscreen="dialog.fullscreen"
              width="700"
              persistent
              scrollable>
              <v-card 
                :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
                class="pa-8 pt-6">
                <v-card-title 
                  class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                  
                  Mengubah Status

                  <v-spacer/>

                  <!-- <v-icon 
                    @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                    class="cursor-pointer mr-1"
                    size="24"
                    color="#718EBF">
                    {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                  </v-icon>

                  <v-icon 
                    @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                    class="cursor-pointer"
                    size="24"
                    color="red">
                    mdi-close-circle-outline
                  </v-icon> -->

                  <v-icon 
                    @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                    class="cursor-pointer"
                    size="18"
                    color="#000000">
                    mdi-close
                  </v-icon>
                </v-card-title>
                
                <!-- <v-divider 
                  class="mb-2"
                  style="border-top: 2px dashed #e0e0e0;"/> -->

                <v-card-text 
                  class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                  Apakah Anda yakin mengubah status data menjadi {{ status }} ?

                  <!-- <v-autocomplete
                    v-if="detail.status === 'pengiriman' || detail.status === 'Set Order'"
                    v-model="status"
                    :items="['pengiriman','diterima customer']"
                    
                    label="Pilih Status"
                    
                    dense
                    outlined
                    hide-details
                    style="width: 100%"
                    class="mt-4"
                    >
                  </v-autocomplete> -->

                  <div v-if="detail.status === 'pengiriman' && form.bpb_arr.length > 0">
                    <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7 mt-6 mb-5"  v-for="(items, indexs) in form.bpb_arr" :key="indexs">
                      <v-card-text>
                        <div class="fs-18 input-label mb-8 font-weight-bold pt-2">
                          BPB Ke-{{ indexs+1 }}
                        </div>
                      <div v-for="(item, index) in items.bpb_detail" :key="index">
                        <!-- {{ index+items.bpb_id }} -->
                        <!-- <table width="100%" style="border-bottom: thin solid #E6EFF5;">
                          <thead>
                            <tr>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Nama Barang</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Lusin</th>
                              <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="(item, index) in form.varian_arr" :key="index">
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_name }}</td>
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_sku }}</td>
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_pcs_approved }}</td>
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_lusin_approved }}</td>
                              <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_dus_approved }}</td>
                            </tr>
                          </tbody>
                        </table> -->
                        <v-card flat class="mb-5" style="background: #718ebf17; border-radius: 15px;">
                          <v-card-text>
                            <div class="fs-16 font-weight-bold label-input">
                              {{ item.varian_name }}
                            </div>
                            <div>
                              <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                            </div>
                            <!-- <div>
                              <span>Harga</span>: <span>{{ item.price | price }}</span>
                            </div> -->

                            <v-row class="pt-3 pb-0">
                              <v-col class="py-0" cols="2">
                                <div 
                                  class="fs-15 label-input">
                                  Qty yang dikirim
                                </div>
                              </v-col>
                              <v-col class="py-0">
                                <div 
                                  class="fs-15 label-input">
                                  Qty yang diterima
                                </div>
                              </v-col>
                              <v-col class="py-0">
                                <div 
                                  class="fs-15 label-input">
                                  Qty yang dikembalikan
                                </div>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col class="py-0" cols="2">
                      
                                <div class="fs-19 font-weight-bold label-input mt-3">
                                  {{ item.qty_pcs }} Pcs
                                </div>
                              </v-col>
                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga
                                </div>

                                <div class="fs-19 font-weight-bold label-input mt-3">
                                  {{ item.price | price }}
                                </div>
                              </v-col> -->

                              <v-col class="py-0">
          
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"
                                  suffix="pcs"

                                  
            
                                  v-model="item.qty_pcs_diterima"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                                <!-- <div class="fs-15 label-input">
                                  Qty
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"

                                  
            
                                  v-model="item.qty"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field> -->
                              </v-col>
                              <v-col class="py-0">
          
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"
                                  suffix="pcs"

                                  
            
                                  v-model="item.qty_pcs_return"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                                <!-- <div class="fs-15 label-input">
                                  Qty
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"

                                  
            
                                  v-model="item.qty"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field> -->
                              </v-col>
                              <!-- <v-col class="py-0" cols="3">
                                <ValidationProvider
                                  :name="`Qty Pcs ${item.varian_name}`"
                                  :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                                  v-slot="{ errors }">
            
                                  <v-currency-field
                                  
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Qty"
                                    suffix="pcs"
              
                                    :value="item.qty_pcs"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </ValidationProvider>
                              </v-col> -->

                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga Beli
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Harga Beli"
                                  
            
                                  v-model="item.harga_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col>

                              <v-col>
                                <div class="fs-15 label-input">
                                  PPN Beli
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="PPN Beli"
                                  
            
                                  v-model="item.ppn_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col> -->
                            </v-row>

                            <v-row>
                              <v-col class="py-0" cols="2">
                      
                                <div class="fs-19 font-weight-bold label-input mt-3">
                                  {{ item.qty_lusin }} Lusin
                                </div>
                              </v-col>
                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga
                                </div>

                                <div class="fs-19 font-weight-bold label-input mt-3">
                                  {{ item.price | price }}
                                </div>
                              </v-col> -->

                              <v-col class="py-0">
          
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"
                                  suffix="lusin"

                                  
            
                                  v-model="item.qty_lusin_diterima"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                                <!-- <div class="fs-15 label-input">
                                  Qty
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"

                                  
            
                                  v-model="item.qty"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field> -->
                              </v-col>
                              <v-col class="py-0">
          
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"
                                  suffix="lusin"

                                  
            
                                  v-model="item.qty_lusin_return"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                                <!-- <div class="fs-15 label-input">
                                  Qty
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"

                                  
            
                                  v-model="item.qty"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field> -->
                              </v-col>
                              <!-- <v-col class="py-0" cols="3">
                                <ValidationProvider
                                  :name="`Qty Pcs ${item.varian_name}`"
                                  :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                                  v-slot="{ errors }">
            
                                  <v-currency-field
                                  
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Qty"
                                    suffix="pcs"
              
                                    :value="item.qty_pcs"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </ValidationProvider>
                              </v-col> -->

                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga Beli
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Harga Beli"
                                  
            
                                  v-model="item.harga_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col>

                              <v-col>
                                <div class="fs-15 label-input">
                                  PPN Beli
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="PPN Beli"
                                  
            
                                  v-model="item.ppn_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col> -->
                            </v-row>

                            <v-row>
                              <v-col class="py-0" cols="2">
                      
                                <div class="fs-19 font-weight-bold label-input mt-3">
                                  {{ item.qty_dus }} Dus
                                </div>
                              </v-col>
                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga
                                </div>

                                <div class="fs-19 font-weight-bold label-input mt-3">
                                  {{ item.price | price }}
                                </div>
                              </v-col> -->

                              <v-col class="py-0">
          
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"
                                  suffix="dus"

                                  
            
                                  v-model="item.qty_dus_diterima"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                                <!-- <div class="fs-15 label-input">
                                  Qty
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"

                                  
            
                                  v-model="item.qty"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field> -->
                              </v-col>
                              <v-col class="py-0">
          
                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"
                                  suffix="dus"

                                  
            
                                  v-model="item.qty_dus_return"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                                <!-- <div class="fs-15 label-input">
                                  Qty
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Qty"

                                  
            
                                  v-model="item.qty"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field> -->
                              </v-col>
                              <!-- <v-col class="py-0" cols="3">
                                <ValidationProvider
                                  :name="`Qty Pcs ${item.varian_name}`"
                                  :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                                  v-slot="{ errors }">
            
                                  <v-currency-field
                                  
                                    filled
                                    rounded
                                    dense
                                    solo
              
                                    color="#718EBF"
                                    placeholder="Qty"
                                    suffix="pcs"
              
                                    :value="item.qty_pcs"
                                    :error-messages="errors"
                                    required
                                    style="border-radius: 10px;">
                                  </v-currency-field>
                                </ValidationProvider>
                              </v-col> -->

                              <!-- <v-col>
                                <div class="fs-15 label-input">
                                  Harga Beli
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="Harga Beli"
                                  
            
                                  v-model="item.harga_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col>

                              <v-col>
                                <div class="fs-15 label-input">
                                  PPN Beli
                                </div>

                                <v-currency-field
                                  
                                  filled
                                  rounded
                                  dense
                                  solo
            
                                  color="#718EBF"
                                  placeholder="PPN Beli"
                                  
            
                                  v-model="item.ppn_beli"
                                  required
                                  style="border-radius: 10px;">
                                </v-currency-field>
                              </v-col> -->
                            </v-row>

                          </v-card-text>
                        </v-card>
                      </div>

                    </v-card-text>
                  </v-card>
                  </div>


                  <div v-if="message.error.length > 0"
                    class="text-left mt-4">
                    <div
                      class="error--text d-flex align-start">
                      <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>


                <!-- <v-divider 
                  class="mt-2"
                  style="border-top: 2px dashed #e0e0e0;"/> -->

                <v-card-actions
                  class="pa-0 pt-4">
                  <v-spacer/>

                  <v-btn
                    rounded
                    @click="save()"
                    :loading="process.form"
                    :disabled="process.form"
                    width="190"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize border-radius">
                    Ya, {{ message.status }}
                  </v-btn>

                  <!-- <v-btn
                    rounded
                    width="120"
                    @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                    :disabled="process.status"
                    outlined
                    class="body-2 font-weight-bold text-capitalize red--text">
                    Batal
                  </v-btn> -->
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-snackbar
              v-model="dialog.snackbar"
              top
              right
              color="green">
              <span 
                class="body-1 font-weight-light white--text"
                v-html="message.success">
              </span>

              <template v-slot:action="{ attrs }">
                <v-btn
                  icon
                  color="white"
                  class="body-1 font-weight-bold text-capitalize"
                  v-bind="attrs"
                  @click="dialog.snackbar = false">
                  <v-icon>mdi-close-circle-outline</v-icon>
                </v-btn>
              </template>
            </v-snackbar>

            <v-dialog v-model="dialog.delete"
              @keydown.esc="dialog.delete = false"
              :fullscreen="dialog.fullscreen"
              width="500"
              persistent
              scrollable>
              <v-card 
                :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
                class="pa-8 pt-6">
                <v-card-title 
                  class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                  
                  Hapus Data

                  <v-spacer/>

                  <!-- <v-icon 
                    @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                    class="cursor-pointer mr-1"
                    size="24"
                    color="#718EBF">
                    {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                  </v-icon>

                  <v-icon 
                    @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                    class="cursor-pointer"
                    size="24"
                    color="red">
                    mdi-close-circle-outline
                  </v-icon> -->

                  <v-icon 
                    @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                    class="cursor-pointer"
                    size="18"
                    color="#000000">
                    mdi-close
                  </v-icon>
                </v-card-title>
                
                <!-- <v-divider 
                  class="mb-2"
                  style="border-top: 2px dashed #e0e0e0;"/> -->

                <v-card-text 
                  class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                  Apakah Anda yakin menghapus data No BPB <b class="font-weight-bold black--text">{{ selected.item[0] }}</b> yang Anda pilih?

                  <div v-if="message.error.length > 0"
                    class="text-center mt-4">
                    <div
                      class="error--text d-flex align-start">
                      <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>


                <!-- <v-divider 
                  class="mt-2"
                  style="border-top: 2px dashed #e0e0e0;"/> -->

                <v-card-actions
                  class="pa-0 pt-4">
                  <v-spacer/>

                  <v-btn
                    rounded
                    @click="deletes()"
                    :loading="process.delete"
                    :disabled="process.delete"
                    width="190"
                    height="45"
                    elevation="0"
                    color="#1814F3"
                    class="fs-16 white--text text-capitalize border-radius">
                    Ya, Hapus
                  </v-btn>

                  <!-- <v-btn
                    rounded
                    width="120"
                    @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                    :disabled="process.delete"
                    outlined
                    class="body-2 font-weight-bold text-capitalize red--text">
                    Batal
                  </v-btn> -->
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog v-model="dialog.bukti"
              @keydown.esc="dialog.bukti = false"
              v-if="dialog.bukti"
              :fullscreen="dialog.fullscreen"
              width="600"
              persistent
              scrollable>
              <v-card 
                :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
                class="">
                <v-card-title 
                  class="d-flex align-center pb-4 text-right popup-header fs-18 font-weight-bold">
                  
                  Bukti Pengiriman

                  <v-spacer/>

                  <!-- <v-icon 
                    @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                    class="cursor-pointer mr-1"
                    size="24"
                    color="#718EBF">
                    {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                  </v-icon>

                  <v-icon 
                    @click="dialog.bukti = false; dialog.fullscreen = false; selected.bukti = [];"
                    class="cursor-pointer"
                    size="24"
                    color="red">
                    mdi-close-circle-outline
                  </v-icon> -->

                  <v-icon 
                    @click="dialog.bukti = false; dialog.fullscreen = false;"
                    class="cursor-pointer"
                    size="18"
                    color="#000000">
                    mdi-close
                  </v-icon>
                </v-card-title>
                
                <v-divider 
                  class="mb-2"
                  style="border-top: 2px dashed #e0e0e0;"/>

                <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0" v-if="selected.detail.length > 0">
                  <table style="width: auto;">
                    <tr>
                      <td class="fs-13 py-1">
                        No BPB
                      </td>
                      <td style="width: 40px" class="fs-13 text-center">
                        : 
                      </td>
                      <td class="fs-13 text-left">
                        {{ selected.detail[0].bpb_number }}
                      </td>
                    </tr>
                    <tr>
                      <td class="fs-13 py-1">
                        Nama Toko
                      </td>
                      <td style="width: 40px" class="fs-13 text-center">
                        : 
                      </td>
                      <td class="fs-13 text-left">
                        {{ selected.detail[0].store_name }}
                      </td>
                    </tr>
                    <tr>
                      <td class="fs-13 py-1">
                        No. Order
                      </td>
                      <td style="width: 40px" class="fs-13 text-center">
                        : 
                      </td>
                      <td class="fs-13 text-left">
                        {{ selected.detail[0].orders_number }}
                      </td>
                    </tr>
                  </table>

                  <div class="mt-2" v-for="(item, index) in selected.detail[0].foto_bukti_json" :key="index">
                    <img 
                      :src="item"
                      alt="Mitra Warung" 
                      style="width: 100%; height: 100%; border: 2px dashed #e0e0e0; border-radius: 8px !important;" />
                  </div>

                  <v-card-text
                    v-if="selected.detail[0].foto_bukti_json.length === 0"
                    class="pb-0 my-4" style="height: 200px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <v-img 
                        class="mx-auto"
                        contain
                        alt="vuetify"
                        :width="90"
                        :height="90"
                        :src="require('@/assets/image/empty.png')">
                        <!-- <template v-slot:placeholder>
                          <v-row
                            class=" "
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template> -->
                      </v-img>
                      <div class="mt-3 fs-16">
                        Belum Ada Data Foto
                      </div>
                    </div>
                  </v-card-text>

                </v-card-text>


                <!-- <v-divider 
                  class="mt-2"
                  style="border-top: 2px dashed #e0e0e0;"/> -->

                <v-card-actions
                  class="">
                  <v-spacer/>

                  <v-btn
                    rounded
                    width="120"
                    @click="dialog.bukti = false; dialog.fullscreen = false;"
                    outlined
                    class="body-2 font-weight-bold text-capitalize red--text">
                    Tutup
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- Page Header -->
            <div class="page-header">
              <div class="header-content px-2">
                <div class="d-flex">
                  <h1>Detail Surat Jalan</h1>
                  <div v-if="Object.keys(detail).length > 0" class="header-badge ml-2" :style="`background: ${getStatusColor(detail.status)};`">
                    <v-icon size="14" color="white">mdi-file-document-outline</v-icon>
                    <span>{{ getStatusText(detail.status) }}</span>
                  </div>
                  <div v-if="$route.query.is_ekspedisi == 1 || $route.query.is_ekspedisi == '1'" class="header-badge ml-2" style="background: linear-gradient(135deg, #F07B3F 0%, #F07B3F 100%);">
                    <v-icon size="14" color="white">mdi-truck-delivery</v-icon>
                    <span>Pakai Ekspedisi</span>
                  </div>
                </div>
                <p v-if="Object.keys(detail).length > 0">Informasi lengkap surat jalan {{ detail.number }}</p>
                <p v-else>Memuat data surat jalan...</p>
              </div>
              <div class="header-actions">
                <v-btn
                  @click="exports()"
                  :loading="process.export"
                  :disabled="process.load || Object.keys(detail).length === 0"
                  depressed
                  small
                  class="elegant-btn-export"
                  style="border-radius: 8px; background: linear-gradient(135deg, #bd1112 0%, #8b0d0e 100%); color: white; box-shadow: 0 3px 12px rgba(189, 17, 18, 0.3);">
                  <v-icon left size="16">mdi-file-pdf-box</v-icon>
                  Export PDF
                </v-btn>
              </div>
            </div>

            <!-- Main Content -->
            <div class="main-card">
              <!-- Loading State -->
              <div v-if="process.load" class="loading-container">
                <v-progress-circular
                  indeterminate
                  color="#00ADB5"
                  size="64"
                  width="6"
                  class="mb-4">
                </v-progress-circular>
                <div class="fs-16 font-weight-medium" style="color: #495057;">
                  Memuat Data Surat Jalan...
                </div>
                <div class="fs-12 mt-2" style="color: #6c757d;">
                  Mohon tunggu sebentar
                </div>
              </div>

              <!-- Detail Information -->
              <div v-if="!process.load && Object.keys(detail).length > 0" class="form-step">
                <div class="step-header">
                  <div class="step-icon teal">
                    <v-icon color="white" size="28">mdi-file-document-outline</v-icon>
                  </div>
                  <div>
                    <h2>Informasi Surat Jalan</h2>
                    <p>Detail lengkap surat jalan pengiriman</p>
                  </div>
                </div>

                <!-- Info Grid Normal (Non-Ekspedisi) -->
                <div v-if="!$route.query.is_ekspedisi || ($route.query.is_ekspedisi != 1 && $route.query.is_ekspedisi != '1')" class="info-grid">
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-identifier</v-icon>
                      No. Surat Jalan
                    </div>
                    <div class="info-value">{{ detail.number }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-account-circle</v-icon>
                      Nama Driver
                    </div>
                    <div class="info-value">{{ detail.driver_name }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-truck</v-icon>
                      Nama Kendaraan
                    </div>
                    <div class="info-value">{{ detail.vehicle_name }} - {{ detail.vehicle_number }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-calendar</v-icon>
                      Tanggal Pengiriman
                    </div>
                    <div class="info-value">{{ detail.date | date }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-information</v-icon>
                      Status
                    </div>
                    <div class="info-value">
                      <v-chip 
                        small
                        :color="getStatusColor(detail.status)"
                        text-color="white"
                        style="font-weight: 600;">
                        {{ getStatusText(detail.status) }}
                      </v-chip>
                    </div>
                  </div>
                  <div class="info-card full-width">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-note-text</v-icon>
                      Catatan
                    </div>
                    <div class="info-value">{{ detail.note === '' ? '-' : detail.note }}</div>
                  </div>
                </div>

                <!-- Card Ekspedisi (Jika Pakai Ekspedisi) -->
                <div v-if="$route.query.is_ekspedisi == 1 || $route.query.is_ekspedisi == '1'">
                  <div class="info-grid mb-4">
                    <div class="info-card">
                      <div class="info-label">
                        <v-icon size="16" class="mr-2" color="#00ADB5">mdi-identifier</v-icon>
                        No. Surat Jalan
                      </div>
                      <div class="info-value">{{ detail.number }}</div>
                    </div>
                    <div class="info-card">
                      <div class="info-label">
                        <v-icon size="16" class="mr-2" color="#00ADB5">mdi-information</v-icon>
                        Status
                      </div>
                      <div class="info-value">
                        <v-chip 
                          small
                          :color="getStatusColor(detail.status)"
                          text-color="white"
                          style="font-weight: 600;">
                          {{ getStatusText(detail.status) }}
                        </v-chip>
                      </div>
                    </div>
                    <div class="info-card full-width">
                      <div class="info-label">
                        <v-icon size="16" class="mr-2" color="#00ADB5">mdi-note-text</v-icon>
                        Catatan
                      </div>
                      <div class="info-value">{{ detail.note === '' ? '-' : detail.note }}</div>
                    </div>
                  </div>

                  <v-card 
                    flat 
                    class="pa-5 mt-4 elegant-ekspedisi-card" 
                    style="background: linear-gradient(135deg, #E8F4F8 0%, #A8D5E2 100%); border-radius: 6px; box-shadow: 0 4px 20px rgba(15, 76, 117, 0.12);">
                    <div class="d-flex align-center mb-4">
                      <v-avatar size="36" style="background: linear-gradient(135deg, #3282B8 0%, #5C9EAD 100%); box-shadow: 0 4px 12px rgba(50, 130, 184, 0.3);" class="mr-3">
                        <v-icon color="white" size="18">mdi-truck-delivery</v-icon>
                      </v-avatar>
                      <div>
                        <div class="fs-17 font-weight-bold" style="color: #2E5266; letter-spacing: -0.3px;">
                          Informasi Ekspedisi
                        </div>
                        <div class="fs-11 mt-1" style="color: #5C9EAD;">
                          Data ekspedisi untuk pengiriman
                        </div>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" md="4">
                        <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                          Nama Driver Ekspedisi
                        </div>
                        <div class="ekspedisi-info-box">
                          <v-icon size="18" class="mr-2" color="#3282B8">mdi-account</v-icon>
                          <span class="ekspedisi-info-value">{{ detail.driver_name || '-' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                          Nama Kendaraan Ekspedisi
                        </div>
                        <div class="ekspedisi-info-box">
                          <v-icon size="18" class="mr-2" color="#3282B8">mdi-truck</v-icon>
                          <span class="ekspedisi-info-value">{{ detail.vehicle_name || '-' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                          Nomor Polisi Kendaraan
                        </div>
                        <div class="ekspedisi-info-box">
                          <v-icon size="18" class="mr-2" color="#3282B8">mdi-numeric</v-icon>
                          <span class="ekspedisi-info-value">{{ detail.vehicle_number || '-' }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </div>


              <!-- BPB Data Table -->
              <div v-if="!process.load && Object.keys(detail).length > 0" class="form-step">
                <div class="step-header">
                  <div class="step-icon orange">
                    <v-icon color="white" size="28">mdi-format-list-bulleted</v-icon>
                  </div>
                  <div>
                    <h2>Data BPB</h2>
                    <p>Daftar BPB yang dikirim dalam surat jalan ini</p>
                  </div>
                  <v-chip 
                    v-if="data_bpb.length > 0"
                    small
                    color="#00ADB5"
                    text-color="white"
                    class="ml-auto"
                    style="font-weight: 600;">
                    {{ data_bpb.length }} BPB
                  </v-chip>
                </div>

                <div class="table-wrapper">
                  <div class="table-scroll-wrapper">
                    <table class="bpb-detail-table">
                      <thead>
                        <tr>
                          <th class="text-center sticky-col" style="min-width: 90px; width: 90px; max-width: 90px;">Aksi</th>
                          <th class="text-left sticky-col" style="min-width: 200px; width: 200px; max-width: 200px;">No BPB</th>
                          <th style="width: 150px; white-space: nowrap;">Tgl Order</th>
                          <th style="width: 180px; white-space: nowrap;">No Order</th>
                          <th style="width: 200px; white-space: nowrap;">Nama Toko</th>
                          <th style="width: 150px; white-space: nowrap;">Nama Sales</th>
                          <th style="width: 150px; white-space: nowrap;">Wilayah</th>
                          <th style="width: 300px; min-width: 300px;">Alamat</th>
                          <th style="width: 200px; white-space: nowrap;">Nama Barang</th>
                          <th style="width: 180px; white-space: nowrap;">{{ detail.status === 'Set Order' ? 'Qty yang akan dikirim' : 'Qty yang dikirim' }}</th>
                          <th style="width: 150px; white-space: nowrap;">Qty yang diterima</th>
                          <th style="width: 150px; white-space: nowrap;">Qty yang dikembalikan</th>
                          <th style="width: 120px; white-space: nowrap;">Qty Dus Muat</th>
                          <th style="width: 120px; white-space: nowrap;">Qty Dus Rusak</th>
                          <th style="width: 150px; white-space: nowrap;">Bukti Pengiriman</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in data_bpb" :key="index">
                          <td class="text-center sticky-col" style="min-width: 90px; width: 90px;">
                            <!-- <v-tooltip 
                              top v-if="detail.status === 'Set Order'">
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="toDelete(item.bpb_id, item.bpb_number)"

                                  v-bind="attrs"
                                  v-on="on"

                                  min-width="28"
                                  small
                                  rounded
                                  color="red"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-trash-can-outline</v-icon>
                                </v-btn>
                              </template>
                              
                              <span>Hapus</span>
                            </v-tooltip> -->

                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  @click="selected.export = item.bpb_id; exportsBpb(item.bpb_id)"
                                  :loading="process.export_bpb && selected.export === item.bpb_id"
                                  elevation="0"
                                  dark
                                  min-height="28"
                                  small
                                  min-width="28"
                                  color="#bd1112"
                                  class="text-capitalize px-0 mx-1"
                                  style="border-radius: 6px;"
                                  v-bind="attrs"
                                  v-on="on">
                                  <v-icon size="18" color="white">mdi-file-pdf-box</v-icon>
                                </v-btn>
                              </template>

                              <span>
                                Export Pdf
                              </span>
                            </v-tooltip>
                          </td>
                          <td class="text-left sticky-col" style="min-width: 200px; width: 200px; max-width: 200px;">{{ item.bpb_number }}</td>
                          <td style="white-space: nowrap;">{{ item.order_date | date }}</td>
                          <td style="white-space: nowrap;">{{ item.orders_number }}</td>
                          <td style="white-space: nowrap;">{{ item.store_name }}</td>
                          <td style="white-space: nowrap;">{{ item.sales_name }}</td>
                          <td style="white-space: nowrap;">{{ item.wilayah }}</td>
                          <td style="min-width: 300px;">
                            {{ item.shipping_province }}, {{ item.shipping_city }}, {{ item.shipping_subdistrict }}, {{ item.shipping_village }}
                          </td>
                          <td style="white-space: nowrap;">{{ item.varian_name }}</td>
                          <td style="white-space: nowrap;">
                            <div v-if="item.qty_pcs*1 > 0">
                              {{ item.qty_pcs }} Pcs
                            </div>
                            <div v-if="item.qty_lusin*1 > 0">
                              {{ item.qty_lusin }} Lusin
                            </div>
                            <div v-if="item.qty_dus*1 > 0">
                              {{ item.qty_dus }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                            </div>
                          </td>
                          <td style="white-space: nowrap;">
                            <div v-if="item.qty_pcs*1 > 0">
                              {{ item.qty_pcs_diterima }} Pcs
                            </div>
                            <div v-if="item.qty_lusin*1 > 0">
                              {{ item.qty_lusin_diterima }} Lusin
                            </div>
                            <div v-if="item.qty_dus*1 > 0">
                              {{ item.qty_dus_diterima }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                            </div>
                          </td>
                          <td style="white-space: nowrap;">
                            <div v-if="item.qty_pcs*1 > 0">
                              {{ item.qty_pcs_return }} Pcs
                            </div>
                            <div v-if="item.qty_lusin*1 > 0">
                              {{ item.qty_lusin_return }} Lusin
                            </div>
                            <div v-if="item.qty_dus*1 > 0">
                              {{ item.qty_dus_return }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                            </div>
                          </td>
                          <td style="white-space: nowrap;">{{ item.qty_dus_muat }}</td>
                          <td style="white-space: nowrap;">{{ item.qty_dus_rusak }}</td>
                          <td class="text-center" style="white-space: nowrap;">
                            <v-tooltip 
                              top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="dialog.bukti = true; selected.detail = [item];"
                                  min-width="28"
                                  small
                                  rounded
                                  color="green"
                                  elevation="0"
                                  class="white--text text-capitalize mx-1 px-0"
                                  style="font-weight: 600; border-radius: 6px;">
                                  <v-icon small>mdi-information-outline</v-icon>
                                </v-btn>
                              </template>

                              <span>Bukti Visit</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- Navigation Buttons -->
              <div class="form-nav">
                <!-- <v-btn
                  to="/delivery/surat-jalan"
                  depressed
                  class="btn btn-outline"
                  style="min-width: 130px;">
                  <v-icon left size="16">mdi-arrow-left</v-icon>
                  Kembali
                </v-btn> -->
                <v-btn
                  to="/delivery/surat-jalan"
                  :disabled="process.form"
                  depressed
                  large
                  class="mr-3 elegant-btn-cancel"
                  style="min-width: 130px; height: 44px; border-radius: 10px; text-transform: none; font-weight: 500; letter-spacing: 0.2px; background: #f5f7fa; color: #5C9EAD;">
                  <v-icon left size="16" class="mr-1">mdi-arrow-left</v-icon>
                  Kembali
                </v-btn>
              </div>
            </div>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  import axios from "axios";
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false,
          fullscreen: false,
          snackbar: false,
          delete: false,
          bukti: false
        },
        status: '',

        detail: {},

        rejected_reason: '',

        form: {
          id: '',
          bpb_arr: []
        },
        category: [],
        branch: [],
        selected: {
          item: [],
          status: [],
          delete: [],
          export: '',
          detail: []
        },
        data_bpb: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null
        },

        process: {
          form: false,

          load: false,

          image_url: false,
          export: false,
          export_bpb: false,
          export: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      getStatusColor (status) {
        const statusMap = {
          'Set Order': '#FFD460',
          'pengiriman': '#F07B3F',
          'diterima': '#00ADB5',
          'pengiriman terkonfirmasi': '#00ADB5'
        }
        return statusMap[status] || '#393E46'
      },
      getStatusText (status) {
        const statusMap = {
          'Set Order': 'Menunggu Pengiriman',
          'pengiriman': 'Pengiriman',
          'diterima': 'Diterima Customer',
          'pengiriman terkonfirmasi': 'Pengiriman Terkonfirmasi'
        }
        return statusMap[status] || status
      },
      async fetchDetail () {
        this.process.load = true
        let params = {
          id: this.$route.params.id
        }
        
        // Hanya tambahkan is_ekspedisi jika ada di query parameter
        if (this.$route.query.is_ekspedisi) {
          params.is_ekspedisi = this.$route.query.is_ekspedisi
        }

        await get('admin/surat_jalan/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.bpb_arr = []
            this.detail = res.results.data
            this.data_bpb = []
            // res.results.data.bpb.map((item, index) => {
            //   this.form.bpb_arr.push({
            //     bpb_id: item.bpb_id,
            //     bpb_detail: item.detail,
            //     foto_bukti_json: item.foto_bukti_json !== null || item.foto_bukti_json !== '' ? JSON.parse(item.foto_bukti_json) : []
            //   })

            //   // res.results.data.bpb.push(item)
            // })

            // console.log(this.form.bpb_arr)

            // this.form.bpb_arr.map((item, index) => {
            //   item.bpb_detail.map((items, indexs) => {
            //     items.bpb_detail_id = items.bpb_detail_id
            //     items.varian_name = items.varian_name
            //     items.varian_sku = items.varian_sku
            //     items.qty_pcs_diterima = items.qty_pcs_diterima
            //     items.qty_dus_diterima = items.qty_dus_diterima
            //     items.qty_lusin_diterima = items.qty_lusin_diterima
            //     items.qty_pcs_return = items.qty_pcs_return
            //     items.qty_dus_return = items.qty_dus_return
            //     items.qty_lusin_return = items.qty_lusin_return
            //     // items.foto_bukti_json = items.foto_bukti_json !== null || items.foto_bukti_json !== '' ? JSON.parse(items.foto_bukti_json) : []
            //   })
            // })

            res.results.data.bpb.map((item, index) => {

              item.detail.map((items, indexs) => {
                this.data_bpb.push({
                  ... items,
                  ... item,
                  foto_bukti_json: item.foto_bukti_json !== null && item.foto_bukti_json !== '' ? JSON.parse(item.foto_bukti_json) : []
                })
              })
            })
          }
          this.process.load = false
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },

      async save () {
        this.message.error = ''
        const isValid = true
        if (isValid) {
          

        this.process.form = true
        let form = this.detail.status == 'Set Order' ? {
          id: this.detail.id
        } : {
          id: this.detail.id,
          bpb_arr: JSON.stringify(this.form.bpb_arr),
        }

        let url = this.detail.status == 'Set Order' ? 'admin/tugas/approve' : 'admin/tugas/confirm'

        await post(url, {
          data: form
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.status = false

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }

        
      },
      async exports (id) {
        this.message.error = ''

        this.process.export = true

        let params = {
          bpb_id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/bpb/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },
      toDelete (id, item) {
        this.selected.delete = [id]
        this.selected.item = [item]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/surat_jalan/update_status_bpb`, {
          data: {
            bpb_id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
      },
      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = {
          id: this.$route.params.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/surat_jalan/Export_surat_jalan_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },
      async exportsBpb (id) {
        this.message.error = ''

        this.process.export_bpb = true

        let params = {
          bpb_id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/surat_jalan/export_bpb_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export_bpb = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>


<style scoped>
/* Elegant Container */
.elegant-container {
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
}

/* Customer Page */
.customer-page {
  position: relative;
  padding: 18px;
  padding-top: 36px;
  min-height: 100%;
}

/* Animated Background */
.animated-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.6;
  animation: float 20s ease-in-out infinite;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  top: -100px;
  right: -50px;
  filter: blur(60px);
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #FFD460 0%, #F07B3F 100%);
  bottom: 100px;
  left: -50px;
  filter: blur(50px);
  animation-delay: -5s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  top: 50%;
  right: 20%;
  filter: blur(40px);
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(5deg); }
  50% { transform: translateY(0) rotate(0deg); }
  75% { transform: translateY(20px) rotate(-5deg); }
}

/* Page Header */
.page-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 28px;
}

.header-content h1 {
  font-size: 18px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
  letter-spacing: -0.5px;
}

.header-content p {
  font-size: 14px;
  color: #393E46;
  margin: 0;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Main Card */
.main-card {
  position: relative;
  z-index: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(34, 40, 49, 0.08);
  border: 1px solid rgba(238, 238, 238, 0.6);
  overflow: hidden;
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  min-height: 400px;
}

/* Form Step */
.form-step {
  padding: 24px;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 32px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f8f9fa;
}

.step-icon {
  width: 42px;
  height: 42px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-icon.teal {
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  box-shadow: 0 8px 20px rgba(0, 173, 181, 0.3);
}

.step-icon.coral {
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  box-shadow: 0 8px 20px rgba(234, 84, 85, 0.3);
}

.step-icon.orange {
  background: linear-gradient(135deg, #F07B3F 0%, #F07B3F 100%);
  box-shadow: 0 8px 20px rgba(240, 123, 63, 0.3);
}

.step-icon.yellow {
  background: linear-gradient(135deg, #FFD460 0%, #FFD460 100%);
  box-shadow: 0 8px 20px rgba(255, 212, 96, 0.3);
}

.step-header h2 {
  font-size: 14px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
}

.step-header p {
  font-size: 12px;
  color: #393E46;
  margin: 0;
}

/* Info Grid */
.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.info-card.full-width {
  grid-column: span 3;
}

.info-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e8eaed;
  transition: all 0.3s ease;
}

.info-card:hover {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.info-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 15px;
  font-weight: 600;
  color: #222831;
  word-break: break-word;
}

/* Table Wrapper */
.table-wrapper {
  margin-top: 8px;
}

.table-scroll-wrapper {
  position: relative;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  max-width: 100%;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 4px 20px rgba(34, 40, 49, 0.06);
}

/* BPB Table */
.bpb-detail-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  min-width: 2000px;
  table-layout: fixed;
}

.bpb-detail-table thead {
  background: linear-gradient(135deg, #0F4C75 0%, #3282B8 100%);
  position: relative;
}

.bpb-detail-table thead::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
}

.bpb-detail-table thead th {
  color: white !important;
  font-size: 13px;
  font-weight: 600;
  padding: 16px 18px;
  text-align: left;
  border: none;
  white-space: nowrap;
  letter-spacing: 0.3px;
}

.bpb-detail-table thead th:first-child {
  border-top-left-radius: 6px;
}

.bpb-detail-table thead th:last-child {
  border-top-right-radius: 6px;
}

.bpb-detail-table tbody tr {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-bottom: 1px solid #f0f0f0;
}

.bpb-detail-table tbody tr:hover {
  background-color: #f8f9fa;
  /* transform: translateY(-2px); */
  /* box-shadow: 0 4px 12px rgba(15, 76, 117, 0.08); */
}

.bpb-detail-table tbody td {
  padding: 16px 18px;
  font-size: 13px;
  color: #424242;
  vertical-align: middle;
  transition: color 0.2s ease;
  border-top: thin solid #E6EFF5;
  border-right: thin solid #E6EFF5;
  border-bottom: thin solid #E6EFF5;
}

.bpb-detail-table tbody tr:hover td {
  color: #2E5266;
}

.bpb-detail-table tbody tr:last-child {
  border-bottom: none;
}

/* Sticky Column */
.bpb-detail-table thead th.sticky-col {
  position: sticky;
  z-index: 10;
  /* background: linear-gradient(135deg, #0F4C75 0%, #3282B8 100%) !important; */
  /* box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1); */
}

.bpb-detail-table thead th.sticky-col:first-child {
  left: 0;
  border-top-left-radius: 6px;
  background: linear-gradient(135deg, #0F4C75 0%, #3282B8 100%) !important;
}

.bpb-detail-table thead th.sticky-col:nth-child(2) {
  left: 90px;
  z-index: 9;
  background: linear-gradient(135deg, #0F4C75 0%, #3282B8 100%) !important;
  background-color: #0F4C75 !important;
}

.bpb-detail-table tbody td.sticky-col {
  position: sticky;
  z-index: 5;
  background: white !important;
  /* box-shadow: 2px 0 4px rgba(0, 0, 0, 0.05); */
}

.bpb-detail-table tbody td.sticky-col:first-child {
  left: 0;
  background-color: #ffffff !important;
  background: #ffffff !important;
}

.bpb-detail-table tbody td.sticky-col:nth-child(2) {
  left: 90px;
  z-index: 4;
  background-color: #ffffff !important;
  background: #ffffff !important;
}

.bpb-detail-table tbody tr:hover td.sticky-col:first-child {
  background: #f8f9fa !important;
}

.bpb-detail-table tbody tr:hover td.sticky-col:nth-child(2) {
  background: #f8f9fa !important;
}

.bpb-detail-table tbody tr:hover td.sticky-col:nth-child(2) {
  background: #f8f9fa;
}

/* Form Navigation */
.form-nav {
  display: flex;
  align-items: center;
  padding: 0px 32px;
  padding-bottom: 24px !important;
  background: transparent;
  justify-content: end;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-outline {
  background: white;
  color: #222831;
  border: 1px solid #EEEEEE;
}

.btn-outline:hover {
  background: #f8f9fa;
  border-color: #00ADB5;
  color: #00ADB5;
}

/* Export Button */
.elegant-btn-export {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.elegant-btn-export:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(189, 17, 18, 0.4) !important;
}

.elegant-btn-export:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Custom Scrollbar */
.table-scroll-wrapper::-webkit-scrollbar {
  height: 10px;
}

.table-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f3f5;
  border-radius: 6px;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #5C9EAD 0%, #3282B8 100%);
  border-radius: 6px;
  border: 2px solid #f1f3f5;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #3282B8 0%, #0F4C75 100%);
}

/* Ekspedisi Info Box */
.ekspedisi-info-box {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e8eaed;
  min-height: 44px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.ekspedisi-info-box:hover {
  border-color: #d0d5dd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.ekspedisi-info-value {
  font-size: 14px;
  font-weight: 500;
  color: #222831;
  flex: 1;
}

/* Responsive */
@media (max-width: 960px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .info-card.full-width {
    grid-column: span 1;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 600px) {
  .surat-jalan-detail-page {
    padding: 16px;
  }
  
  .header-content h1 {
    font-size: 22px;
  }
  
  .form-step {
    padding: 18px;
  }
  
  .bg-shape {
    opacity: 0.3;
  }
}
</style>